import script from "./warning-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./warning-table.vue?vue&type=script&lang=ts&setup=true"

import "./warning-table.vue?vue&type=style&index=0&id=216b9844&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216b9844"]])

export default __exports__